<template>
  <div>
    <div>
      <input
        :ref="uniqueKey"
        type="file"
        :name="uniqueKey"
        :id="uniqueKey"
        @change="fileSelected()"
      />
      <label v-if="!isFileSelected" :ref="`label${uniqueKey}`" :for="uniqueKey"
        >Choose File</label
      >
    </div>
    <div
      class="d-flex fileuploadfolder justify-content-center mb-2"
      v-if="(fileName != '')"
    >
      <div class="mr-4 filename">
        <b>{{ fileName }}</b>
      </div>
      <div class="mr-3">
        <font-awesome-icon
          class="fa-1x text-danger deleteicon"
          :icon="['fas', 'trash-alt']"
          @click="removeUploadedFile()"
        />
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "FileUpload",
  props: ["uniqueKey","fileName"],
  methods: {
    fileSelected() {
      let file = this.$refs[this.uniqueKey].files[0];
      this.fileName=file.name;
      this.$emit("fileSelected", file);
    },
    removeUploadedFile() {
      let that = this;
      document.getElementById(this.uniqueKey).value = "";
      this.$emit("fileRemoved", this.fileName, function() {
        that.fileName = "";
      });
    }
  },
  data() {
    return {
      isFileSelected:false
    };
  },
  watch:{
    fileName:function (newVal)
    {
      if(newVal!="")
      {
        this.isFileSelected=true;
      }
      else{
        this.isFileSelected=false;
      }
    }

  }
};
</script>
<style>
.fileuploadfolder {
  padding: 4px;
  width: 100%;
  margin: auto;
  border: 2px dotted #618bb7;
  align-items: center;
}

.deleteicon {
  transition: 1s all;
}

.deleteicon:hover {
  transform: scale(1.5) rotate(360deg);
}

.fileuserdetails {
  position: relative;
  width: 80%;
  margin: auto;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-top: 0.5rem;
}

.uploadbuttonanimation {
  animation: buttonanimation 1.5s infinite;
}

.fileuploadfolder .uploadicon {
  animation: uploadzoominout 1.5s infinite;
  color: #618bb7 !important;
}

@keyframes uploadzoominout {
  0% {
    transform: scale(1, 1);
  }
  50% {
    transform: scale(1.5, 1.5);
  }
  100% {
    transform: scale(1, 1);
  }
}

@keyframes buttonanimation {
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0.5;
  }
  100% {
    opacity: 1;
  }
}
</style>